import React, { FC, useState, useEffect, ReactNode } from "react";
import injectSheet from "react-jss";
import { Row, Column } from "simple-flexbox";

import styleSheet from "./styles";

interface Props {
  classes: any;
  isOpen: boolean;
}

const maincontent: FC<Props> = ({ classes, isOpen, children }) => (
  <Column className={classes.mainContent}>{children}</Column>
);

export const MainContent = injectSheet(styleSheet)(maincontent);
